import { useEffect, useState } from 'react';
import { logMessage } from '../utils/logMessage';

export function useSpeechTokenRefresh(fetchSpeechToken: Function) {
  const [speechCredentials, setSpeechCredentials] = useState<{ token: string; region: string } | null>(null);

  useEffect(() => {
    let mounted = true;
    let tokenRefreshInterval: NodeJS.Timeout | null = null;

    const refreshToken = async () => {
      try {
        const { token, region } = await fetchSpeechToken();
        if (mounted) setSpeechCredentials({ token, region });
      } catch (err) {
        logMessage(
          '[Speech Token Refresh] Failed to refresh speech token',
          'info',
          {error: JSON.stringify(err)}
        );
      }
    };

    refreshToken();
    tokenRefreshInterval = setInterval(() => {
      refreshToken();
    }, 480000);

    return () => {
      mounted = false;
      if (tokenRefreshInterval) clearInterval(tokenRefreshInterval);
    };
  }, []);

  return { speechCredentials, setSpeechCredentials };
}